<template>
    <mu-col span="12" class="bg-dark menu-lang-line">
        <div class="d-flex justify-content-end align-items-center">
			<mu-button flat href="/facturacion">
				<span class="text-white">{{ $t('button_action.invoicing') }}</span>
			</mu-button>
			<div v-if="profile != null">
				<mu-menu cover class="menu-profile">
					<mu-button flat>
						<mu-icon value="account_circle" size="20" color="#14f314"></mu-icon>
						<span class="text-name ml-2">{{ profile.first_name}}</span>
					</mu-button>
					<div slot="content" :z-depth="4" style="width: 235px; height: 100%;" class="menu-profile-content">
						<mu-col span="12" class="mt-2">
							<h6 style="color: #005296" class="d-flex justify-content-center align-items-center">
								<span>{{ $t('alt.frecuent_traveller') }}</span> 
								<mu-icon value="directions_bus"></mu-icon>
							</h6>
						</mu-col>
						<mu-col span="12" class="mt-2 text-center" style="color: #005296; font-size: 0.8em;">
							<span>{{ $t('alt.name') }} - {{ `${profile.first_name} ${profile.last_name} ${profile.second_surname}` }}</span>
							<br />
							<span>{{ profile.card_number }}</span>
						</mu-col>
						<mu-divider></mu-divider>
						<mu-col span="12" class="mt-2 d-flex justify-content-center align-items-center">
							<mu-button flat small class="my-2" color="red" @click="logOut">
								<mu-icon value="logout"></mu-icon>
								{{ $t('button_action.logout') }}
							</mu-button>
						</mu-col>
					</div>
				</mu-menu>
			</div>
        </div>
    </mu-col>
</template>
<script>
// HELPERS
import _FrequentTravellerHelper from '@/store/helpers/frequenttraveller/frequenttraveller'
import _GlobalHelper from '@/store/helpers/global'
// IMG
import mx from '@@/images/mx.png'
import us from '@@/images/us.svg'

// VUEX
import { mapMutations, mapGetters } from 'vuex'
export default {
    data() {
        return {
            countries: [
				{
					img: mx,
					tag: 'es  (mx)'
				},
				{
					img: us,
					tag: 'en  (us)'
				}
			],
			select_country: mx,
        }
    },
    computed: {
		...mapGetters({
			language: _GlobalHelper.getters.language,
			profile: _FrequentTravellerHelper.mutations.profile
		}),

		lang: {
			set() {

			},
			get() {
				return this.language
			}
		},

		loading: {
			set(data) {
				this.setLoading(data)
			},
			get() {

			}
		}
	},
	watch: {
		travellerSession(data) {
			//console.log(data)
		}
	},
	methods: {
		...mapMutations({
			setLanguage: _GlobalHelper.mutations.language,
			setAlertSimple: _GlobalHelper.mutations.setAlertSimple,
			setAuthenticate: _GlobalHelper.mutations.setAuthenticate,
			setLoading: _GlobalHelper.mutations.loading,
			setPrfile: _FrequentTravellerHelper.mutations.profile
		}),

		changeLanguage(obj) {
			this.select_country = obj.img
			let lang = obj.tag.split(' ')
			this.setLanguage(lang[0])
		},

		checkLanguage() {
			for (let country of this.countries) {
				let lang = country.tag.split(' ')
				if (lang[0] === this.lang) {
					this.select_country = country.img
				}
			}
		},

		closeDrawer() {
			this.open_drawer = false
		},

		openSignIn() {
			this.setAuthenticate({
				show: true
			})
			this.open_drawer = false
		},
		logOut() {
			this.loading = {
				show: true,
				message: `
                <mu-container>
                    <h5>${this.$i18n.t('loading.logout')}</h5>
                </mu-container>`
            }

			this.activeTooltip = false
			setTimeout(() => {
				this.setPrfile(null)
				this.loading = { show: false, message: null }
			}, 500)
		},
	},
	created() {
		this.lang == 'es' ? (this.select_country = mx) : (this.select_country = us)
	}
}
</script>

<style lang="scss" scoped>
.menu-lang-line{
    margin-top: -1px;
    background-color: #000000;

    .menu-lang {
        max-height: 30px;
    }

    .mu-menu-activator{
        .mu-raised-button{
            max-height: 26px;
        }
    }
    .mu-item-title:hover{
        text-decoration: none;
    }
    .img-select {
        width: 30px !important;
        height: 18px !important;
    }
}
.menu-profile{
	.text-name{
		color: white;
		text-transform: none;
	}

	.menu-profile-content{
		.mu-popover{
			border-radius: 20px !important;
		}
	}
}

</style>